import { Injectable } from '@angular/core';
import { GungTroubleshootingService } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class JeevesTroubleshootingService extends GungTroubleshootingService {
  public getErpSpecificProductBlockedTranslateTag(): string {
    return 'JEEVES_PRODUCT_BLOCKED_EXTRA_TEXT';
  }
}
